import Dashboard from "./Pages/Dashboard";
import VueRouter from "vue-router"
import Profile from "@/Pages/Profile";


export default new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile
    },
    {
      path: '/payments',
      name: 'payments',
      component: () => import('./Pages/Payments')
    },
    {
      path: '/subscriptions',
      name: 'subscriptions',
      component: () => import('./Pages/Subscriptions')
    }
  ]
});
